import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1q83xmlpct: FaireBrandEntity = {
  token: "b_1q83xmlpct",
  type: "brand",
  name: "Maxine's Heavenly",
  avatarUrl:
    "https://cdn.faire.com/fastly/44acd0efe7b61677ee08e6c711465cbece00b65a3cab8ecb955b43baddf7abfe.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2a45751c32022d10774858859eea0d64ae8fc77ef2762aaefd03ed67e4722539.png",
  logoUrl:
    "https://cdn.faire.com/fastly/44acd0efe7b61677ee08e6c711465cbece00b65a3cab8ecb955b43baddf7abfe.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2a45751c32022d10774858859eea0d64ae8fc77ef2762aaefd03ed67e4722539.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 22,
  isTopShop: true,
  isInsider: true,
  description:
    "Maxine’s Heavenly makes delicious, homemade-style cookies that are Sweetened By Nature™.\n \nOur family loved our mom’s decadent cookies, but not the ingredients. So, we started with Maxine’s beloved recipe, and substituted ingredients one by one, taking out all the processed flours and sugars, gluten, animal products and with them, all the empty calories. We replaced them each with better-for-you alternatives that preserved that special taste while making the cookie nutrient-rich and guilt-free.\n \nFrom this great adventure came Maxine’s Heavenly. Our cookies are still very much a part of Maxine, but speak to what we know today about healthy eating.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:34.684Z",
    importedBy: "entity-db-cli",
  },
};
